export const version = '2.16.7';
//# sourceMappingURL=version.js.map